import NavBar from "../components/NavBar";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="min-h-screen">
      <NavBar></NavBar>
      <div className="mx-auto px-8 md:py-16 flex flex-col items-center">
        <div className="rounded-lg max-w-6xl flex md:gap-16 flex-col md:flex-row md:items-center md:bg-gray-200">
          <div className="md:basis-[40%] hidden md:block">
            <img
              className="m-8 rounded-lg"
              src="/hero thin.png"
              alt="people talking"
            ></img>
          </div>
          <div className="px-8 py-12 flex flex-col items-start gap-8 md:basis-[60%]">
            <h1 className="text-4xl lg:text-5xl font-semibold text-gray-900 text-center mx-auto md:mx-0 md:text-left md:mb-3">
              Our Yes List
            </h1>
            <p className="text-xl text-gray-600 text-center md:mb-8 md:text-left">
              Take the “Our Yes List” Quiz to explore what you and your partner
              both enjoy. Fill it out together or separately if you prefer. The
              quiz helps spark open, comfortable conversations about what
              excites you both.
            </p>
            <Link
              className="w-64 mx-auto bg-green-500 text-white text-center py-4 rounded-lg text-lg font-semibold hover:bg-green-400 transition-colors"
              to="/quiz-introduction"
            >
              Start The Quiz
            </Link>
          </div>
          <div className="md:basis-[40%] md:hidden">
            <img className="" src="/hero.png" alt="people talking"></img>
          </div>
        </div>
        <div className="flex flex-col gap-4 items-center mt-16 md:mt-24 lg:mt-32 max-w-5xl">
          <h3 className="font-semibold">What is this site?</h3>
          <p className="text-gray-600">
            This site is all about open, honest communication and mutual
            consent. It’s designed to help you and your partner talk about what
            you both enjoy and what you don’t. As you go through the activity
            questions together, the goal isn’t just to find matches, but to
            start real conversations about your preferences, boundaries, and
            comfort levels. It’s a simple tool to make those talks easier, more
            natural, and judgment-free.
          </p>
          <h3 className="font-semibold mt-8 lg:mt-16">Privacy</h3>
          <p className="text-gray-600">
            Your privacy comes first. Everything you do on this site stays
            completely private. Nothing you type or select is ever uploaded or
            saved anywhere, it all happens right on your device. If you refresh
            or close the page, everything disappears, just like starting fresh.
            No accounts, no tracking, no data stored.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
